import { ref } from "vue";

const POINTER_OFFSET = 14;

/** Minimum hit-target size (px) so tiny chart segments remain hoverable. */
export const CHART_MIN_HIT_SIZE = 12;

export function useChartHoverTooltip() {
  const tip = ref(null);

  function show(event, text) {
    if (!text) return;
    tip.value = {
      text,
      x: event.clientX,
      y: event.clientY - POINTER_OFFSET,
    };
  }

  function move(event) {
    if (!tip.value) return;
    tip.value = {
      ...tip.value,
      x: event.clientX,
      y: event.clientY - POINTER_OFFSET,
    };
  }

  function hide() {
    tip.value = null;
  }

  return { tip, show, hide, move };
}

/** Expand a horizontal segment hit area when the bar is narrower than minW. */
export function horizontalHitArea(x, y, w, h, minW = CHART_MIN_HIT_SIZE) {
  if (!(w > 0) || !(h > 0)) return null;
  if (w >= minW) return { x, y, w, h };
  const hitW = minW;
  return { x: x + w / 2 - hitW / 2, y, w: hitW, h };
}

/** Expand a vertical segment hit area when the bar is shorter than minH (anchored at baseline). */
export function verticalHitArea(x, y, w, h, minH = CHART_MIN_HIT_SIZE) {
  if (!(w > 0) || !(h > 0)) return null;
  if (h >= minH) return { x, y, w, h };
  const hitH = minH;
  return { x, y: y + h - hitH, w, h: hitH };
}
